module.exports = __webpack_public_path__ + "media/images/escape-from-agent-50afcb31a441e4db6db70c1fae9182f2.png";